import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createAction,
  deleteAction,
  getUpdatedTasks,
  markAsCompleteAction,
  markAsIncomplete
} from 'src/api/task';

const initialState = {
  uncompleted: [],
  completed: [],
  totalUncompleted: 0,
  totalCompleted: 0
};

const filterEmpty = (tasks) => tasks.filter(({ title }) => Boolean(title));

/* eslint-disable camelcase */
export const createTask = createAsyncThunk(
  'tasks/create',
  async ({ idea_external_id, tasklist_external_id, title, description }) => {
    await createAction({
      task: {
        // the api errors out when sending a description longer than 500 lines
        description: description.slice(0, 500),
        idea_external_id,
        tasklist_external_id,
        title
      }
    });
    return getUpdatedTasks();
  }
);
/* eslint-enable camelcase */

export const deleteTask = createAsyncThunk('tasks/delete', async (task) => {
  await deleteAction({ task });
  return getUpdatedTasks();
});

export const completeTask = createAsyncThunk('tasks/complete', async (task) => {
  await markAsCompleteAction({ task });
  return getUpdatedTasks();
});

export const unCompleteTask = createAsyncThunk(
  'tasks/uncomplete',
  async (task) => {
    await markAsIncomplete({ task });
    return getUpdatedTasks();
  }
);

const setUncompletedTasksReducer = (state, payload) => {
  const uncompleted = filterEmpty([...(payload || [])]);
  state.uncompleted = uncompleted;
  state.totalUncompleted = uncompleted.length;
};

const setCompletedTasksReducer = (state, payload) => {
  const completed = filterEmpty([...(payload || [])]);
  state.completed = completed;
  state.totalCompleted = completed.length;
};

export const tasksSlice = createSlice({
  name: 'tasks',
  initialState: initialState,
  reducers: {
    setUncompleted(state, action) {
      setUncompletedTasksReducer(state, action.payload);
    },
    setCompleted(state, action) {
      setCompletedTasksReducer(state, action.payload);
    }
  },
  extraReducers(builder) {
    const updateTasks = (state, action) => {
      setUncompletedTasksReducer(state, action.payload.uncompleted);
      setCompletedTasksReducer(state, action.payload.completed);
    };

    builder
      .addCase(deleteTask.fulfilled, updateTasks)
      .addCase(createTask.fulfilled, updateTasks)
      .addCase(completeTask.fulfilled, updateTasks)
      .addCase(unCompleteTask.fulfilled, updateTasks);
  }
});

// Action creators are generated for each case reducer function
export const { setUncompleted, setCompleted } = tasksSlice.actions;

export const selectUncompletedTasks = (state) => state.tasks.uncompleted;
export const selectCompletedTasks = (state) => state.tasks.completed;

export const findTaskByRecommendationId = (tasks, recommendationId) => {
  const [idea] = tasks?.filter(
    (currentIdea) => currentIdea.recommendation_id === recommendationId
  );

  return idea;
};

export const selectTaskByRecommendationId = (recommendationId) => (state) =>
  findTaskByRecommendationId(state.tasks.uncompleted, recommendationId);

export default tasksSlice.reducer;
